"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_mail__read(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "mail-read-hi"), /*#__PURE__*/React.createElement("g", {
    id: "77b99e6b-cdb7-4bec-ad81-78f465757df3",
    "data-name": "mail-read-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "150e179e-f09f-4ac5-9f3d-838f61b69f5c",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "435ce303-8bbb-4f4c-b7ef-d7a271e1a609",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "50df0c9f-aa5d-4a37-877b-1f661fb1ff3a",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fda1d40a-2d66-47bb-8642-0ab59e94b46a",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4ea6ad28-57ed-4df3-8cd2-bfee99552369",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "187184cf-6300-4098-b058-048fc51be3cb",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "23587bdb-8725-428c-8893-7c0f9ad995e4",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a4118cc5-0c69-4d7a-9f54-6c00d32c5e18",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "87f1d135-703c-44c4-bce9-363ece21b304",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "763cb7ee-3771-4e80-9c59-144132261774",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4fdb846e-34e9-4c80-b3a1-f329e2775e8f",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1290dfad-d9bc-4bcb-abd7-8cdaed458f24",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2642a705-df8a-4485-ab28-5f1efb689112",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "965825ef-0103-4940-901e-f6fcdb686732",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b8f4e4c4-342d-4417-8459-f7314b8a78e1",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3e20ff04-7a68-4e74-9897-9ab2b8525eb0",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08ddba16-4402-4180-ad69-e8146d3bc2e1",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,72l68,42s5.83,4,12,4,12-4,12-4l68-42",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,116c-6.17,0-12-4-12-4L16,70v2l68,42s5.83,4,12,4,12-4,12-4l68-42V70l-68,42S102.17,116,96,116Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,118c-6.17,0-12-4-12-4L16,72v80a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16V72l-68,42S102.17,118,96,118Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,166H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-2A16,16,0,0,1,160,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,72H176V68.46a8,8,0,0,0-3.8-6.81L108,21.5s-5.83-4-12-4-12,4-12,4L19.8,61.66A8,8,0,0,0,16,68.46Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,72H176V68.46a8,8,0,0,0-3.8-6.81L108,21.5s-5.83-4-12-4-12,4-12,4L19.8,61.66A8,8,0,0,0,16,68.46Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b3d84f07-eb17-4662-93f5-0b9d5646ffa4",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }))))))))))))))))))));
}

var _default = ic_mail__read;
exports.default = _default;